module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/Wild_symbol@1x.png?0.0.53";